import { Box, Divider, type SxProps, type Theme, Typography } from '@mui/material'
import React from 'react'

export interface ThingsToConsiderSection {
  title: string
  subTitle?: JSX.Element
  items: Array<JSX.Element | string>
}
interface Props {
  sections: ThingsToConsiderSection[]
  sx?: SxProps<Theme>
  dataTestId?: string
}
export const ThingsToConsiderCard = (props: Props): JSX.Element => {
  return <Box
    data-testid={props.dataTestId ?? 'thingsToConsiderCard'}
    sx={{
      display: 'flex',
      backgroundColor: 'var(--white)',
      border: '1px solid var(--blue-300)',
      borderRadius: '8px',
      padding: '24px',
      position: 'absolute',
      zIndex: 5,
      gap: '24px',
      width: 'calc(100% - (2 * 24px) - 8px)', // width is 100% minus padding
      ...props.sx
    }}
  >
    {props.sections.map((section, index) => {
      const isLast = index === props.sections.length - 1
      return <React.Fragment key={section.title + index.toString()}>
        <Box sx={{ flex: '1' }}>
          <Typography sx={{ mb: '.75em' }} variant='h5'>{section.title}</Typography>
          {section.subTitle != null && section.subTitle}
          <ul>
            {section.items.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </Box>

        {!isLast && <Divider orientation='vertical' sx={{ height: 'auto', borderColor: 'var(--blue-300)' }} />}
      </React.Fragment>
    })}
  </Box>
}
